import { render, staticRenderFns } from "./pos-Purchase.vue?vue&type=template&id=22d57e42"
import script from "./pos-Purchase.vue?vue&type=script&lang=js"
export * from "./pos-Purchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports